
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offer/friend",
      function () {
        return require("private-next-pages/offer/friend/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offer/friend"])
      });
    }
  